import React from "react";
import { useTranslation } from "react-i18next";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import { LightningBlock } from "./LightningBlock";

export const BenefitBlock = ({
  benefitText,
  positionTop,
  positionLeft = "",
  positionRight = "",
  maxWidth,
}: {
  benefitText: string;
  positionTop: string;
  positionLeft?: string;
  positionRight?: string;
  maxWidth: string;
}) => {
  const { t } = useTranslation(["affiliates"]);
  const langTheme = useLanguageTheme();

  return (
    <div
      className="benefit-block-wrapper"
      style={{
        top: positionTop,
        left: positionLeft,
        right: positionRight,
        fontFamily: langTheme.mainFont(),
        maxWidth: maxWidth,
      }}
    >
      <div className="benefit-block-container">
        <div className="benefit-block-text">{t(benefitText)}</div>
        <LightningBlock />
      </div>
    </div>
  );
};
